import base from '../base'
import { getRequest, postJsonRequest, blobJsonRequest } from '@utils/request'
const cloud = `prescription/${base.appCode}`
const QUICKPRESCRIBE = {

  // 获取处方充值门店
  getRechargeStore(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/getBuyPresStore`, params)
  },

  // 获取处方充值列表
  getRechargeList(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/getPresTopUpList`, params)
  },

  // 获取处方使用数据
  getPrescribeCount(params = {}) {
    return getRequest(`${base.baseUrl}/${cloud}/api/prestopup/getStoreTopUpCount`, params)
  },

  // 获取支付二维码
  getPaymentImage(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/getPayQRCodeInfo`, params)
  },

  // 获取门店处方
  getStorePrescribe(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/getPayQRCodeInfo`, params)
  },

  // 处方预警服务设置
  savePrescribeWarn(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/setServiceConfig`, params)
  },

  // 获取处方预警服务设置
  getPrescribeWarn(params = {}) {
    return getRequest(`${base.baseUrl}/${cloud}/api/prestopup/getServiceConfig`, params)
  },

  // 设置药方折扣
  saveStoreRebate(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/setStoreDidcount`, params)
  },

  // 获取开通处方充值的药商
  getRechargePharmacist(params = {}) {
    return getRequest(`${base.baseUrl}/${cloud}/api/prestopup/getOpenPresBuyPharma`, params)
  },

  // 药商处方统计
  getPrescribeCensus(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/getPresStatistics`, params)
  },

  // 导出处方充值明细
  exportRechargeList(params = {}) {
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/exportPresTopUpList`, params)
  },

  // 门店支付统计导出
  exportStoreCensus(params = {}) {
    return blobJsonRequest(`${base.baseUrl}/${cloud}/api/prestopup/exportPresStatistics`, params)
  },

  // 根据订单编号查询订单信息
  getOrderInfo(params = {}, loading = false) {
    return getRequest(`${base.baseUrl}/${cloud}/api/prestopup/getStorePresOrderByOrderSeq`, params, loading)
  },

  // 查询药房信息
  getPharmacyInfo(params = {}) {
    return getRequest(`${base.baseUrl}/${cloud}/api/prestopup/getStoreInfo`, params)
  }

}

export default QUICKPRESCRIBE



// WEBPACK FOOTER //
// ./src/api/modules/quickPrescribe.js